import { Loader2 } from "lucide-react";

export function Spinner({ label, size = 16 }: { label?: string; size?: number }) {
  return (
    <span className="inline-flex items-center gap-2 text-slate-600 dark:text-slate-300">
      <Loader2 className="animate-spin" size={size} aria-hidden />
      {label && <span className="text-sm">{label}</span>}
    </span>
  );
}
